export default angular
  .module('doxy.common.components.slideToggle', [])
  .directive('dSlideToggle', function ($timeout) {
    return {
      restrict: 'A',
      scope: {
        dSlideToggle: '=',
      },
      link: function (scope, element, attr) {
        var pureElement = element[0];
        var duration = parseInt(attr.dDuration);
        scope.$watch('dSlideToggle', function (newValue) {
          function getElemHeight() {
            return pureElement.getBoundingClientRect().height;
          }

          var isHidden = element.hasClass('hidden');
          if ((isHidden && !newValue) || (!isHidden && newValue)) {
            return;
          }

          var startStyles = {
            overflow: 'hidden',
          };
          var newHeight;
          if (newValue) {
            element.removeClass('hidden');
            newHeight = getElemHeight();
            startStyles.height = '0px';
          } else {
            newHeight = 0;
            startStyles.height = getElemHeight() + 'px';
          }

          element.css(startStyles);

          function setNewHeight() {
            element.css({
              height: newHeight + 'px',
            });
            $timeout(function () {
              if (!newHeight) {
                element.addClass('hidden');
              }

              element.css({
                height: null,
                overflow: null,
              });
            }, duration);
          }

          $timeout(setNewHeight);
        });
      },
    };
  }).name;
